<template>
  <div class="form-panel">     
    <div class="form-panel__body">
      <div class="form-fields form-fields-invertido">          
        <div class="form-fields__principal">
          <h2 class="titulo-h3-light">Ingresa una nueva contraseña para {{ email }}</h2> 
          <form class="form" action="">
            <div class="form__group" :class="{'form__group-invalid': $v.form.password.$error, 'form__group-valid': !$v.form.password.$invalid}">
              <i class="icon-field icon-field-password"></i>
              <label for="password">Contraseña</label>
              <input id="password" type="password" @blur="$v.form.password.$touch()" v-model="form.password">
              <div class="form__group-validation" v-if="$v.form.password.$dirty">
                <p v-if="!$v.form.password.required">Ingresa una contraseña.</p>
                <p v-if="!$v.form.password.minLength">Ingresa al menos 6 caracteres.</p>
              </div>
            </div>
            <div class="form__group" :class="{'form__group-invalid': $v.form.confirmPassword.$error, 'form__group-valid': !$v.form.confirmPassword.$invalid && !$v.form.password.$invalid}">             
              <i class="icon-field icon-field-password"></i>
              <label for="confirm-password">Repetir Contraseña</label>
              <input id="confirm-password" type="password" @blur="$v.form.confirmPassword.$touch()" v-model="form.confirmPassword" @keyup.enter="$v.form.$invalid ? $v.form.$touch() : restablecer()">
              <div class="form__group-validation" v-if="$v.form.confirmPassword.$dirty">
                <p v-if="!$v.form.confirmPassword.sameAs">Ingresa exactamente la misma contraseña.</p>
              </div>
            </div>
            <div class="form__group form__group-register">
              <a class="waves-effect waves-light m-btn" tabindex="0" @click="$v.form.$invalid ? $v.form.$touch() : restablecer()" @keyup.enter="$v.form.$invalid ? $v.form.$touch() : restablecer()">Restablecer</a>               
            </div> 
          </form>
        </div>        
      </div>
    </div>
  </div>   
</template>

<script>

import { required, email, minLength, sameAs } from 'vuelidate/lib/validators';

export default {
  data(){
    return{
      email: '',
      code: '',
      form:{
        password: '',
        confirmPassword: ''
      }      
    };
  },
  created() {
    if (!this.$route.query.email || !this.$route.query.code) {
      this.$route.push({ name: 'home' })
      return
    }

    this.email = this.$route.query.email.replace('simbolo-arroba', '@')
    this.code = this.$route.query.code
  },
  methods:{
    restablecer()
    {
      const data = {
        email: this.email,
        password: this.form.password,
        confirmPassword: this.form.confirmPassword,
        code: this.code
      }
      this.$store.dispatch('resetPassword', data)
    }
  },
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(6)
      },
      confirmPassword: {
        sameAs: sameAs('password')
      }
    }    
  }
}
</script>